import { Shadows } from '@mildang/mui';

const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;

function createShadow(
  ...px: [number, number, number, number, number, number, number, number, number, number, number, number]
) {
  return [
    `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(43,45,54,${shadowKeyUmbraOpacity})`,
    `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(43,45,54,${shadowKeyPenumbraOpacity})`,
    `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(43,45,54,${shadowAmbientShadowOpacity})`,
  ].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows: Shadows = [
  // @ts-ignore
  'none',
  'inset 0px -1px 0px #E4E4E7',
  '0px 1px 1px -1px rgba(43, 45, 54, 0.12), 0px 1px 2px -1px rgba(43, 45, 54, 0.06), 0px 1px 4px rgba(43, 45, 54, 0.08)',
  '0px 2px 3px -2px rgba(43, 45, 54, 0.15), 0px 1px 4px -1px rgba(43, 45, 54, 0.12), 0px 4px 8px rgba(43, 45, 54, 0.08)',
  '0px 5px 8px -2px rgba(43, 45, 54, 0.16), 0px -1px 4px -1px rgba(43, 45, 54, 0.06)',
  '0px 8px 8px -5px rgba(43, 45, 54, 0.08), 0px 12px 20px -1px rgba(43, 45, 54, 0.12), 0px 8px 28px 2px rgba(43, 45, 54, 0.08)',
  '0px 12px 12px -8px rgba(43, 45, 54, 0.08), 0px 24px 28px -1px rgba(43, 45, 54, 0.12), 0px 12px 32px 2px rgba(43, 45, 54, 0.08)',
  createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
  createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
  createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
  createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
  createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
  createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
  createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
  createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
  createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
  createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
  createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
  createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
  createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
  createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
  createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
  createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
  createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
  createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8),
];

export const dividerLight = {
  bottom: 'inset 0px -1px 0px #F7F7FA',
  top: 'inset 0px 1px 0px #F7F7FA',
  left: 'inset 1px 0px 0px #F7F7FA',
  right: 'inset -1px 0px 0px #F7F7FA',
};

export const dividerDark = {
  bottom: 'inset 0px -1px 0px #EDEDF0',
  top: 'inset 0px 1px 0px #EDEDF0',
  left: 'inset 1px 0px 0px #EDEDF0',
  right: 'inset -1px 0px 0px #EDEDF0',
};

export default shadows;
